export default __webpack_public_path__ + "static/media/03 - CRUD Operations.0a81fe64.png";